import { Stack, useLocalSearchParams } from 'expo-router';
import { useMemo } from 'react';

import { SimplyMenuRedirect } from '@fhs/menu/src/components/simply-menu-redirect';
import MenuScreenV2 from '@fhs/routing/src/routes/v2/menu/(menu)';
import StoreSelected from '@fhs-legacy/frontend/src/components/store-selected';
import MenuContent from '@fhs-legacy/frontend/src/pages/menu-content';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { isNative } from '@fhs-legacy/frontend/src/utils/environment';
import { isItemPickerOrComboRoute, isSectionRoute } from '@fhs-legacy/frontend/src/utils/routing';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function MenuItemPage() {
  const { id, rewardBenefitId, rewardId, isEdit } = useLocalSearchParams<{
    id: string;
    rewardBenefitId: string;
    rewardId: string;
    isEdit: string;
  }>();

  const isEditBoolean = isEdit === 'true';

  const sectionRoute = isSectionRoute(`/menu/${id}`);
  const itemPickerOrComboRoute = isItemPickerOrComboRoute(`/menu/${id}`);
  const { getCurrentCartEntry } = useOrderContext();
  const appliedLoyaltyRewards = useAppSelector(selectors.loyalty.selectAppliedLoyaltyRewards);

  const hasAppliedRewards = useMemo(
    () => (isEditBoolean ? !!appliedLoyaltyRewards[getCurrentCartEntry()?.cartId] : false),
    [isEditBoolean, appliedLoyaltyRewards, getCurrentCartEntry]
  );

  const isReward = Boolean(rewardBenefitId || rewardId) || hasAppliedRewards;

  // TODO(simplified-menu): Remove when simplified menu is out of beta
  const enableSimplifiedMenuBeta = useFlag<boolean>(LaunchDarklyFlag.ENABLE_SIMPLIFIED_MENU_BETA);
  const enableSimplifiedMenuBetaDetailView = useFlag<boolean>(
    LaunchDarklyFlag.ENABLE_SIMPLIFIED_MENU_BETA_DETAIL_VIEW
  );

  if (enableSimplifiedMenuBeta && sectionRoute) {
    return <MenuScreenV2 />;
  }

  if (enableSimplifiedMenuBetaDetailView && itemPickerOrComboRoute && !isReward) {
    return <SimplyMenuRedirect legacySlug={id} />;
  }

  return (
    <StoreSelected>
      <Stack.Screen options={{ headerShown: isNative }} />
      <MenuContent />
    </StoreSelected>
  );
}
